import { Tooltip } from 'platform/components';
import { Text, ThemeTextColorPath } from 'platform/foundation-tw';
import { CurrencyFormat, useFormatCurrency } from 'platform/locale';
import { isNil, join, pipe, split } from 'ramda';
import { isNotNilOrEmpty, mapIndexed } from 'ramda-adjunct';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getStylesToRender } from '../../utils/getStylesToRender';
import { getTooltipProps } from '../../utils/getTooltipProps';
type MoneyValue = {
  amount: number;
  currency: string;
} | null;
type MoneyWithoutDecimalCellRendererProps = CellRendererProps<MoneyValue> & {
  getTooltipProps?: TooltipGetter;
};
type CellStyle = {
  textColor?: ThemeTextColorPath;
};
const removeDecimal = (val: string, index: number): string => {
  if (index === 1) {
    return val.slice(2);
  }
  return val;
};
const formatMoney = pipe<string[], [string, string], [string, string], string>(
// @ts-ignore
split(','), mapIndexed(removeDecimal), join(' '));
export function MoneyWithoutDecimalCellRenderer(props: MoneyWithoutDecimalCellRendererProps) {
  const className = getCellClassName(props.column);
  const cellStyles = getStylesToRender(props) as CellStyle | undefined;
  const formatCurrency = useFormatCurrency();
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);
  if (isNil(props.value)) {
    return null;
  }
  const value = isNotNilOrEmpty(props.value.amount) ? formatCurrency(props.value.amount, props.value.currency, 2) : null;
  if (isNil(value)) {
    return null;
  }
  const formattedMoney = formatMoney(value) as string;
  return <Tooltip {...tooltipProps} label={formattedMoney}>
      <div className={className}>
        <Text color={cellStyles?.textColor} noWrap={!props.column?.wrapText} size="small" overflowWrap={props.column?.wrapText ? 'anywhere' : undefined}>
          <CurrencyFormat currency={props.value.currency} number={props.value.amount} decimals={0} />
        </Text>
      </div>
    </Tooltip>;
}